import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "./usercontext";

export const CartContext = React.createContext();

export const CartProvider = ({ children }) => {
    const [cart, setCart] = useState([]);
    const [total, setTotal] = useState(0);
    const {user} = useContext(AuthContext);

    useEffect(() => {
        var i = 0, temp = 0;
        for(i = 0; i < cart.length; i++){
            temp = temp + cart[i].price * cart[i].count;
        }
        setTotal(temp);

        if (user === null){
            setCart([]);
        }
    },[cart, user]);



    return (
        <CartContext.Provider value={{ cart, setCart, total }}>{children}</CartContext.Provider>
    );
};